import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router'
import wizardsShape from 'core/components/wizard/shapes'
import * as routes from 'core/routing/constants/index'

const TradeIn = props => {
  const { history, setWizards, wizards, resetTradeInWizard, tradeInConfig } = props

  const extendedWizard = { ...wizards, previousWizard: 'stock' }

  setWizards(extendedWizard)
  resetTradeInWizard(tradeInConfig)

  history.push(routes.REDIRECT_TO_ROUTE_TRADEIN)
}

TradeIn.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  setWizards: PropTypes.func.isRequired,
  resetTradeInWizard: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired,
  tradeInConfig: PropTypes.shape().isRequired
}

export default withRouter(TradeIn)
